const Record = () => import('@/views/main/live/record/Record.vue')
export default {
  path: '/main/live/record',
  name: 'Record',
  component: Record,
  children: []
}
